import {AfterViewInit, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'questionnaire-title',
  templateUrl: './questionnaire-title.component.html',
  styleUrls: ['./questionnaire-title.component.css']
})
export class QuestionnaireTitleComponent implements OnInit, AfterViewInit {
  @Input() questionnaireTitle: string;

  constructor() {}

  ngOnInit() {


  }

  ngAfterViewInit(){

  }


}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-title/questionnaire-title.component.ts